import React from "react";
import { useTheme } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import { i18n } from "../../../translate/i18n";

// Variables acumuladas durante el recorrido (0383 FS-2.13).
// Son las FlowVariables reales del ticket sandbox: lo que evaluarían los nodos `condition`.
const SimVariablesPanel = ({ variables }) => {
  const theme = useTheme();
  const entries = Object.entries(variables || {});
  if (entries.length === 0) return null;

  return (
    <Box
      style={{
        borderTop: `1px solid ${theme.palette.divider}`,
        padding: theme.spacing(1, 1.25),
      }}
    >
      <Typography
        variant="caption"
        style={{ fontWeight: 600, color: theme.palette.text.secondary }}
      >
        {i18n.t("flowbuilders.simulator.variablesTitle") || "Variables del flujo"}
      </Typography>
      <Box mt={0.5} display="flex" flexDirection="column" style={{ gap: 2 }}>
        {entries.map(([key, value]) => (
          <Box key={key} display="flex" style={{ gap: 6, fontSize: 11 }}>
            <span style={{ color: theme.palette.primary.main, fontWeight: 600 }}>
              {`{{${key}}}`}
            </span>
            <span
              style={{
                color: theme.palette.text.secondary,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              title={value}
            >
              {value}
            </span>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SimVariablesPanel;
